(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["feminine-gift-wrap"] && !Shopify.designMode) return;
  try {
    if (!window.feminineGiftWrapInitialized) {
    window.feminineGiftWrapInitialized = true;
    let updatingGiftWrap = false;

    document.addEventListener('change', async (event) => {
      const checkbox = event.target.closest('.feminine-gift-wrap__checkbox');
      if (!checkbox) return;
      if (updatingGiftWrap) return;
      updatingGiftWrap = true;

      const component = checkbox.closest('[data-feminine-gift-wrap]');
      const status = component.querySelector('[data-gift-wrap-status]');
      const allCheckboxes = document.querySelectorAll('.feminine-gift-wrap__checkbox');
      const shouldAdd = checkbox.checked;

      allCheckboxes.forEach((input) => {
        input.disabled = true;
      });

      try {
        const cartResponse = await fetch(component.dataset.cartUrl, {
          headers: { Accept: 'application/json' }, cache: 'no-store',
        });
        if (!cartResponse.ok) throw new Error('Cart could not be read');
        const currentCart = await cartResponse.json();
        const variantId = Number(component.dataset.variantId);
        const wrappingLines = currentCart.items.filter(item => item.variant_id === variantId);
        const hasPhysicalItems = currentCart.items.some(item => item.requires_shipping && item.variant_id !== variantId);
        if (shouldAdd && !hasPhysicalItems) throw new Error('Gift wrapping requires a physical product');

        let request;
        if (shouldAdd && !wrappingLines.length) {
          request = { url: component.dataset.addUrl, body: { items: [{ id: variantId, quantity: 1 }] } };
        } else if (wrappingLines.length) {
          const updates = {};
          wrappingLines.forEach((item, index) => { updates[item.key] = shouldAdd && index === 0 ? 1 : 0; });
          request = { url: component.dataset.updateUrl, body: { updates } };
        }

        if (!request) { window.location.reload(); return; }

        const response = await fetch(request.url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(request.body),
        });

        if (!response.ok) throw new Error('Gift wrap cart update failed');
        window.location.reload();
      } catch (error) {
        checkbox.checked = !shouldAdd;
        status.textContent = component.dataset.errorMessage;
        allCheckboxes.forEach((input) => {
          input.disabled = false;
        });
      } finally {
        updatingGiftWrap = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
